import { render, staticRenderFns } from "./KriterOnayFormu.vue?vue&type=template&id=c2353d9e&scoped=true"
import script from "./KriterOnayFormu.vue?vue&type=script&lang=js"
export * from "./KriterOnayFormu.vue?vue&type=script&lang=js"
import style0 from "./KriterOnayFormu.vue?vue&type=style&index=0&id=c2353d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2353d9e",
  null
  
)

export default component.exports